export function OAuthRedirect(){
    let href=window.location.href;
    if (href.includes("web/?code")) {  //url包括 vue/?code 证明为从微信跳转回来的
       var url = href.substring(0, href.length - 2); //vue自动在末尾加了 #/ 符号，截取去掉
        var sharpPosit = url.indexOf("web/") + 4; //获取域名结束的位置
        var urlLeft = url.substring(0, sharpPosit);//url左侧部分
        var urlRight = url.substring(sharpPosit, url.length); //url右侧部分
        window.location.href=urlLeft + "#/" + urlRight
    }

}